<template>
  <span class="md-badge--component">
    <span class="md-badge" v-if="count != 0">{{count}}</span>
    <slot></slot>
  </span>
</template>
<script>
export default {
  props: {
    count: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {};
  }
};
</script>
<style lang='scss' scoped>
.md-badge--component {
  position: relative;
  .md-badge {
    position: absolute;
    top: 0;
    right: 10px;
    transform: translateY(-50%) translateX(100%);
  }
}
.md-badge {
  background-color: $red;
  border-radius: 10px;
  color: #fff;
  display: inline-block;
  font-size: $font-size-small;
  height: 18px;
  line-height: 16px;
  padding: 0 5px;
  text-align: center;
  white-space: nowrap;
  border: 1px solid #fff;
  vertical-align: middle;
}
</style>